import { render, staticRenderFns } from "./BioTopBar.vue?vue&type=template&id=7ef7031b&scoped=true&"
import script from "./BioTopBar.vue?vue&type=script&lang=ts&"
export * from "./BioTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./BioTopBar.vue?vue&type=style&index=0&id=7ef7031b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7031b",
  null
  
)

export default component.exports